angular.module("ainapp")
    .controller("approvalDeliveryNote2Controller", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, window) {

            //            $scope.PageName = "Purchase Invoices Approval";
            //            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            //            if ($scope.TokenInfo == null) {
            //                $state.go("login");
            //            } else {
            //                $scope.checkUserPageAccess($scope.PageName);
            //            }
            //
            //            $scope.init = function () {
            //                $scope.filter = {
            //                    Keyword: "",
            //                    IsLinkPending: false,
            //                };
            //            }
            //            $scope.init();

            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            $scope.IsAdmin = false;
            if ($scope.TokenInfo.Role == "Admin" || $scope.TokenInfo.Role == "admin" || $scope.TokenInfo.Role == "SA" || $scope.TokenInfo.Role == "CA" || $scope.TokenInfo.Role == "0") {
                $scope.IsAdmin = true;
            }


            $scope.SalesSource = new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        MainService.DeliveryNote2ForApprovals(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success(false);
                            toastr.error($scope.NetworkErrorLan);
                        })
                    }
                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },
                            DueDate: {
                                type: "date",
                            },
                            VoucherNumber: {
                                type: "string",
                            },
                            LinkedRefNos: {
                                type: "string",
                            },
                            "Customer.Name": {
                                type: "string",
                            },

                            NetTotal: {
                                type: "float",
                            },
                            TotalTax: {
                                type: "float",
                            },
                            GrandTotal: {
                                type: "float",
                            },
                            CalcGrandTotal: {
                                type: "float",
                            },
                            ConversionRate: {
                                type: "float",
                            },
                            CreatedDate: {
                                type: "date",
                            },
                            "CreatedBy.UserName": {
                                type: "string",
                            }
                        }
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
            });

            $scope.SalesFactory = {
                toolbar: ["excel"],
                stretch: true,
                selectable: true,
                groupable: false,
                height: 550,
                sortable: true,
                resizable: true,
                dataSource: $scope.SalesSource,
                pageable: true,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                filterable: true,

                columns: [
                    {
                        field: "VoucherNumber",
                        title: "#",
                        headerTemplate: "{{LanguageData.vouchernumber}}",
                                            },
                    {
                        field: "LinkedRefNos",
                        title: "Linked Refs",
                    },
                    {
                        field: "Customer.Name",
                        title: "Supplier",
                        headerTemplate: "{{LanguageData.Supplier}}",
                        width: '250px'
                                            },
                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                        headerTemplate: "{{LanguageData.Date}}",
                                            },

                    {
                        field: "NetTotal",
                        title: "NetTotal",
                        headerTemplate: "{{LanguageData.NetTotal}}",
                        template: "<div style='text-align: right'>#=kendo.toString(NetTotal, 'n')#</div>",

                                            },
                    {
                        field: "TotalTax",
                        title: "Total Tax",
                        headerTemplate: "{{LanguageData.TotalTax}}",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalTax, 'n')#</div>",

                                            },
                    {
                        field: "GrandTotal",
                        title: "Grand Total",
                        headerTemplate: "{{LanguageData.GrandTotal}}",
                        template: "<div style='text-align: right'>#=kendo.toString(GrandTotal, 'n')#</div>",

                                            },
                    {
                        field: "ConversionRate",
                        title: "Conv Rate",
                        template: "<div style='text-align: right'>#=kendo.toString(ConversionRate, 'n')#</div>",
                                            },
                    {
                        field: "CalcGrandTotal",
                        title: "Calc Grand Total",
                        template: "<div style='text-align: right'>#=kendo.toString(CalcGrandTotal, 'n')#</div>",
                                            },
                    {
                        field: "CreatedDate",
                        template: "#= kendo.toString(kendo.parseDate(CreatedDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Created Date"
                                            },

                    {
                        field: "CreatedBy.UserName",
                        title: "Created By"
                                            },
                    {
                        field: "DueDate",
                        template: "#= kendo.toString(kendo.parseDate(DueDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Due Date",
                        headerTemplate: "{{LanguageData.DueDate}}",
                                                                    },

                                                                    {
                                                                        title: "Options",
                                                                        headerTemplate: "{{LanguageData.Options}}  ",
                                                                        template: "<div ng-if='!IsAdmin'><button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button ng-if=\"dataItem.ApprovalStatus == 'Submitted' \" class=' btn-default btn-sm fa fa-thumbs-up'  ng-click='Approve(dataItem)'>Approve</button>   <button ng-if=\"dataItem.ApprovalStatus == 'Submitted' \" class=' btn-default btn-sm fa fa-thumbs-down'  ng-click='Reject(dataItem)'>Reject</button> <button ng-if=\"dataItem.ApprovalStatus == 'Voucher Rejected' \" class=' btn-default btn-sm fa fa-save'  ng-click='Resubmit(dataItem)'>Re Submit</button></div><div ng-if='IsAdmin'><button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button  class=' btn-default btn-sm fa fa-thumbs-up'  ng-click='Approve(dataItem)'>Approve</button>   <button class=' btn-default btn-sm fa fa-thumbs-down'  ng-click='Reject(dataItem)'>Reject</button> ",
                                                                        width: '220px'
                                                                    },


                                        ],
            };

             $scope.Edit = function (data) {
                $state.go("editDeliveryNote2", {
                    VoucherId: data.Id
                })
            };

            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: "",
                };
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            };

            $scope.SearchKendo = function () {
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            }

            $scope.Approve = function (data) {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.ApproveDeliveryNote2(data.Id).then(function (response) {
                    if (response.data == "Success") {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning(response.data);
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.Resubmit = function (data) {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.ResubmitDeliveryNote2(data.Id).then(function (response) {
                    if (response.data == "Success") {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning(response.data);
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.RejectData = {
                VoucherId: "",
                Reason: "",
            };

            $scope.Reject = function (data) {
                $scope.RejectData = {
                    VoucherId: data.Id,
                    Reason: "",
                };

                $('#rejectModal').modal('show');
            }

            $scope.ConfirmReject = function () {

                if ($scope.RejectData.Reason == "") {
                    toastr.warning("Enter Reason");
                } else {
                    $scope.load = true;
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.RejectDeliveryNote2($scope.RejectData).then(function (response) {
                        if (response.data == "Success") {
                            toastr.success("Success");
                            $scope.refresh();
                            $('#rejectModal').modal('hide');
                        } else {
                            toastr.warning(response.data);
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function () {
                        toastr.error("NetworkError");
                        $scope.working = false;
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    })
                }

            }

           
            $scope.View = function (data) {
                var url = $state.href('viewDeliveryNote2', {
                        VoucherId: data.Id
                    });
                    window.open(url, '_blank');
            }

        }])
